import api from "@/services/api";

export interface CreateAssociatePayload {
  name: string;
  phone: string;
  email: string;
  document: string;
  transactionPercent?: number;
  signaturePercent?: number;
  franchiseId: string;
  usePremiumVoucher?: boolean;
}

class CreateAssociate {
  execute = async (payload: CreateAssociatePayload) => {
    const response = await api().post("/new-collaborator", payload);
    return response.data;
  };
}

export { CreateAssociate };




